import {
  DeleteOrganizationAgencyLinkRequestBodyType,
  DeleteOrganizationAgencyLinkResponseBodyType,
} from "@intelligems/ig-types";
import { adminKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const deleteOrganizationAgencyLink = async (
  data: ApiRequest<DeleteOrganizationAgencyLinkRequestBodyType, any, any>
) => {
  const resp = await api.delete<DeleteOrganizationAgencyLinkResponseBodyType>(
    `/v2/admin/organization-agency-links`,
    {
      data: data.body,
    }
  );
  return resp.data;
};

export const useDeleteOrganizationAgencyLink = () => {
  const queryClient = useQueryClient();
  return useMutation<
    DeleteOrganizationAgencyLinkResponseBodyType,
    Error,
    ApiRequest<DeleteOrganizationAgencyLinkRequestBodyType, any, any>,
    any
  >({
    mutationFn: async (data) => deleteOrganizationAgencyLink(data),
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: adminKeys.agency(variables.queryParams.agencyId),
      });
      void queryClient.invalidateQueries({
        queryKey: adminKeys.organizationAgencyLink(
          variables.queryParams.agencyId
        ),
      });
    },
  });
};
